import config from '../config';

export const getDefaultShowLink = (show) => {
  if (!show) {
    return null;
  }
  const defaultShowDomain = show.domain ? `http://${show.domain}` : null;
  const defaultShowWebsite = show.isHosted ? `${config.showsUrl}/${show.alias || show._id}` : null;

  return show.link || defaultShowDomain || defaultShowWebsite;
};

export const getFeedUrl = (show) => {
  if (!show) {
    return null;
  }
  let url = `${config.feedUrl}/public/shows/${show._id}`;

  if (show.isPrivate) {
    url += `?token=${show.accessToken}`;
  }
  return url;
};

export const getPublicFeedUrl = (show) => `${config.feedUrl}/public/shows/${show?._id}`;
